import React from 'react';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import LuminateSummaryPage from './LuminateSummaryPage';
import LuminateAggSummaryPage from './LuminateAggSummaryPage';
import LuminateArtistsSummaryPage from './LuminateArtistsSummaryPage';

/**
 * Luminate has five views. Rather than five header links, they share one tab
 * with a pill selector, matching how Snoop sits inside Unsigned.
 *
 * `path` keeps the standalone deep-link routes working: landing on
 * /luminate/agg selects that view, and switching views updates ?view= so the
 * selection survives a reload or a shared link.
 */
const VIEWS = [
  { id: 'tracks', label: 'Tracks', path: '/luminate', Component: LuminateSummaryPage },
  { id: 'agg', label: 'By Artist', path: '/luminate/agg', Component: LuminateAggSummaryPage },
  { id: 'artists', label: 'Artists', path: '/luminate/artists', Component: LuminateArtistsSummaryPage },
];

export default function LuminatePage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Path is the source of truth. ?view= is still honoured on /luminate so the
  // Agg view — which has no pill — stays reachable at /luminate?view=agg.
  const byPath = VIEWS.find(
    (v) => v.path !== '/luminate' && location.pathname.startsWith(v.path)
  );
  const viewParam = searchParams.get('view');
  const active =
    byPath?.id ||
    (VIEWS.some((v) => v.id === viewParam) ? viewParam : 'tracks');

  const setActive = (next) => {
    const view = VIEWS.find((v) => v.id === next);
    if (view && view.path !== location.pathname) navigate(view.path);
  };

  const Active = (VIEWS.find((v) => v.id === active) || VIEWS[0]).Component;

  return (
    <div>
      <div className="mb-3 flex flex-wrap items-center gap-1.5">
        {VIEWS.map((view) => (
          <button
            key={view.id}
            type="button"
            onClick={() => setActive(view.id)}
            className={`rounded-full px-3 py-1.5 text-sm font-medium transition-colors ${
              active === view.id
                ? 'bg-red-600 text-white'
                : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'
            }`}
          >
            {view.label}
          </button>
        ))}
      </div>
      <Active />
    </div>
  );
}
